import 'styles/lib.scss';
import 'styles/main.scss';

import { loginAndRedirect, logoutAndRedirect } from 'redux/actions/userActions.js';
import { history, persistor, store } from 'redux/lib/configureStore.js';

import App from 'App';
import { ConnectedRouter } from 'connected-react-router';
import LogRocket from 'logrocket';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import { initializeReplaceAllShim } from 'lib/shim/replaceAll';
import jwtDecode from 'jwt-decode';
import setupLogRocketReact from 'logrocket-react';

let token = localStorage.getItem('token');
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  // dev code)
} else {
  // production code
  LogRocket.init('wwtzpn/leadloop');
  setupLogRocketReact(LogRocket);
}

if (token !== null && token !== 'undefined' && token !== 'null') {
  let jwt;
  try {
    jwt = jwtDecode(token);
  } catch (e) {
    localStorage.removeItem('token');
  }
  if (!jwt || jwt.exp < Date.now() / 1000) {
    localStorage.removeItem('token');
    logoutAndRedirect({ saveRedirectPath: true });
  } else {
    loginAndRedirect(token);
  }
}

initializeReplaceAllShim();

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);
